
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.4894 32.8082H11.5107C7.91859 32.8082 6.06086 31.9426 4.99787 30.7397C3.86342 29.456 3.0361 27.1298 3.02532 22.8922H36.9747C36.9639 27.1298 36.1366 29.456 35.0021 30.7397C33.9391 31.9426 32.0814 32.8082 28.4894 32.8082ZM36.9748 19.867H3.02521V15.7493C3.02521 15.4306 3.02979 15.1226 3.03875 14.825H36.9613C36.9702 15.1226 36.9748 15.4306 36.9748 15.7493V19.867ZM36.6708 11.7997H3.32915C3.6698 9.89162 4.27075 8.64054 4.99787 7.81775C6.06086 6.61489 7.91859 5.74933 11.5107 5.74933H28.4894C32.0814 5.74933 33.9391 6.61489 35.0021 7.81774C35.7293 8.64054 36.3302 9.89162 36.6708 11.7997ZM28.4894 35.8334H11.5107C3.44577 35.8334 0 31.9342 0 22.8082V15.7493C0 6.62328 3.44577 2.72412 11.5107 2.72412H28.4894C36.5542 2.72412 40 6.62328 40 15.7493V22.8082C40 31.9342 36.5542 35.8334 28.4894 35.8334Z","fill":"#16171F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.9292 40C34.1407 40 40 34.1574 40 26.9292C40 19.701 34.1407 13.8584 26.9292 13.8584C19.7177 13.8584 13.8584 19.701 13.8584 26.9292C13.8584 34.1574 19.701 40 26.9292 40Z","fill":"#E61845"}}),_c('path',{attrs:{"d":"M29.9164 31.7675C30.3101 32.1611 30.9483 32.1611 31.342 31.7675C31.7356 31.3738 31.7356 30.7356 31.342 30.342L28.267 27.267C28.096 27.096 28 26.8642 28 26.6224V19C28 18.4477 27.5523 18 27 18C26.4477 18 26 18.4477 26 19V27.42C26 27.696 26.1096 27.9607 26.3048 28.1559L29.9164 31.7675Z","fill":"white"}})])
          )
        }
      }
    